import { createApp } from '@app/adapters/create-app'

import ReportGraphsSubnavControls from '@app/application/report/components/report-graphs-subnav-controls.vue'

window.onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='report-graphs-subnav-controls']")
    .each(function () {
      createApp(ReportGraphsSubnavControls, {
        title: this.dataset.title,
        titleTooltip: this.dataset.titleTooltip,
      }).mount(this)
    })
})
